import { CrewMemberUserLinkReason, CrewMemberUserLinkReasons, LaborSkuReason, LaborSkuReasons, LaborSkuSetting, TenantDiagnostics } from "./tenantDiagnosticsApi"
import { laborSkuSettingLabels } from "./tenantsModel"

const crewMemberUserLinkReasonDescriptions: Record<CrewMemberUserLinkReason, string> = {
  [CrewMemberUserLinkReasons.UserNotFound]: 'No user account exists with this email address',
  [CrewMemberUserLinkReasons.UserDeleted]: 'The linked user account has been deleted',
  [CrewMemberUserLinkReasons.UserInactive]: 'The linked user account is inactive'
}

const laborSkuReasonDescriptions: Record<LaborSkuReason, string> = {
  [LaborSkuReasons.NotSet]: 'No SKU is configured',
  [LaborSkuReasons.ItemNotFound]: 'No catalog item has this SKU',
  [LaborSkuReasons.ItemRetired]: 'The catalog item with this SKU is retired',
  [LaborSkuReasons.ItemNotLabor]: 'The catalog item with this SKU is not a labor item',
  [LaborSkuReasons.DuplicateSku]: 'More than one catalog item has this SKU'
}

export const describeCrewMemberUserLinkReason = (reason: CrewMemberUserLinkReason): string => {
  return crewMemberUserLinkReasonDescriptions[reason] ?? reason
}

export const describeLaborSkuSetting = (setting: LaborSkuSetting): string => {
  return laborSkuSettingLabels[setting] ?? setting
}

export const describeLaborSkuReason = (reason: LaborSkuReason): string => {
  return laborSkuReasonDescriptions[reason] ?? reason
}

export const countTenantDiagnosticsIssues = (diagnostics: TenantDiagnostics | undefined): number => {
  if (!diagnostics) {
    return 0
  }

  return diagnostics.crewMemberUserLinkIssues.length + diagnostics.laborSkuIssues.length
}
